module.exports = {
	"naslov": "Čekaš da prođe rat",
	"slika": "fotke/1941/1941-09-27-sabac-odvodjenje-roma-na-streljanje",
	"opis": "Lojalan si okupatoru u svom domu. Nemci upadaju po kućama i odvode civile na streljanje. Zakucali su na tvoja vrata.",
	"pitanje": "Šta će biti s tobom?",
	"akcija": "Baci kockicu da saznaš.",
	"ishodi": [
		{
			"naslov": "Ishod 1",
			"opis": "Zarobljen si...."
		},
		{
			"naslov": "Ishod 3",
			"opis": "Izvukao si se..."
		},
		{
			"mrtav": "mrtav"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/09-24/podaci.json
// module id = 45
// module chunks = 0